import { isDefined } from "@clipboard-health/util-ts";
import { Link, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { Text, Title } from "@src/appV2/redesign/system/ui-components";
import { type ReactNode } from "react";

interface BadgeVerificationExplanationLayoutProps {
  title: string;
  subtitle?: string;
  onViewBadgePolicy: () => void;
  onNext: () => void;
  children: ReactNode;
}

export function BadgeVerificationExplanationLayout(props: BadgeVerificationExplanationLayoutProps) {
  const { title, subtitle, onViewBadgePolicy, onNext, children } = props;

  return (
    <>
      <Stack spacing={7} sx={{ paddingX: 5, paddingBottom: 2 }}>
        <Stack spacing={4} alignItems="center" textAlign="center">
          <Title variant="h2" component="h2" sx={(theme) => ({ color: theme.palette.error.light })}>
            {title}
          </Title>
          {isDefined(subtitle) && (
            <Text variant="body1" sx={(theme) => ({ color: theme.palette.error.light })}>
              {subtitle}
            </Text>
          )}
        </Stack>

        {children}

        <Stack alignItems="center">
          <Link
            component="button"
            variant="body1"
            sx={{ verticalAlign: "baseline" }}
            onClick={onViewBadgePolicy}
          >
            View badge policy
          </Link>
        </Stack>
      </Stack>

      <DialogFooter orientation="vertical">
        <Button fullWidth variant="contained" size="large" onClick={onNext}>
          Next
        </Button>
      </DialogFooter>
    </>
  );
}
